import { api } from "./client";

export interface ReminderParams {
  visibility?: string;
  status?: string;
  priority?: string;
  page?: number;
  pageSize?: number;
}

export function getReminders(params?: ReminderParams) {
  return api.get("/reminders", { params });
}

export function getDueCount(params?: { today?: string }) {
  return api.get<{ count: number }>("/reminders/due-count", { params });
}

export function createReminder(data: Record<string, unknown> | object) {
  return api.post("/reminders", data);
}

export function updateReminder(
  id: string,
  data: Record<string, unknown> | object
) {
  return api.patch(`/reminders/${id}`, data);
}

export function deleteReminder(id: string) {
  return api.delete(`/reminders/${id}`);
}

export function completeReminder(id: string, data?: { notes?: string }) {
  return api.post(`/reminders/${id}/complete`, data);
}
